module.exports = __webpack_public_path__ + "images/mobile/img-dingtalk-warn-d73e65f519944b4ff6509bcb63d25565.png";